import {
  ChevronDownRegularIcon,
  HouseMedicalChimneyRegularIcon,
} from "@elixir/icons";
import { InputField } from "ui";
import { useMyAccessProfileV2 } from "../../../apis/tryst/get-my-access-profile";

export default function SelectDoctorForSlot({
  selectedDoctorId,
  setSelectedDoctorId,
  clinicId,
}: {
  selectedDoctorId?: string;
  setSelectedDoctorId: (docId: string) => void;
  clinicId: string;
}) {
  const { data: myAccessProfile } = useMyAccessProfileV2({ clinicId });

  return (
    <div className="dr-px-16 dr-py-8 dr-flex dr-flex-col dr-space-y-16">
      <p>Select Doctor</p>
      <InputField
        suggestions={myAccessProfile?.doctors.map((item) => ({
          id: item.oid,
          name: item.name,
        }))}
        value={
          myAccessProfile?.doctors?.find(
            (item) => item.oid === selectedDoctorId
          )?.name
        }
        onSuggestionSelect={({ id }): void => {
          setSelectedDoctorId(id);
        }}
        customSuffix={
          <div className="dr-h-full dr-flex dr-items-center dr-justify-center dr-px-12 dr-rounded-r-8">
            <ChevronDownRegularIcon className="dr-w-14 dr-h-14 dr-text-darwin-touch-neutral-400" />
          </div>
        }
        customPrefix={
          <div className="dr-h-full dr-flex dr-items-center dr-justify-center dr-pl-12 dr-rounded-r-8">
            <HouseMedicalChimneyRegularIcon className="dr-w-16 dr-h-16" />
          </div>
        }
      />
    </div>
  );
}
